import { useContext } from 'react';
import { DisplayAdsContext } from "../../context/displayAds";

export default function useDisplayAds() {
	return useContext(DisplayAdsContext);
}